 
import React, { FC } from 'react';
import { IOption as IRadioGroupOption } from '@/components/radiogroup-control/contract';
import { RadioGroup } from '@/components/radiogroup-control/radiogroup';
import { IProps, IOption } from './contract';
import { Theme, useTheme } from '@mui/material/styles';

// Define styles for MUI v7
const getStyles = (theme: Theme) => ({

  //this css  styled is not working 
  // formlabelRoot: {
  //   paddingBottom: '0px !important',
  //   backgroundColor: 'yellow !important',
  // },
  // formgroupRoot: {
  //   '& span:nth-child(1) > label > span': {
  //     borderRadius: '5px 0 0 5px !important',
  //   },
  //   '& span:nth-last-child(1) > label > span': {
  //     borderRadius: '0 5px 5px 0 !important',
  //   },
  //   backgroundColor: 'red !important',
  // },
  // formControlLabelRoot: {
  //   margin: '0px !important',
  //   backgroundColor: 'green !important',
  // },
  // formControlLabel: { 
  //   position: 'absolute !important',
  //   width: '1px !important',
  //   height: '1px !important',
  //   padding: '0px !important',
  //   margin: '-1px !important',
  //   overflow: 'hidden !important',
  //   clip: 'rect(0, 0, 0, 0) !important',
  //   whiteSpace: 'nowrap !important',
  //   border: '0px !important',
  //   backgroundColor: 'blue !important',
  // },
  radio: {
    borderRadius: '5px !important',
    
    backgroundColor: `${theme.palette.grey[300]} !important`,
    '&:hover': {
      backgroundColor: '#fff !important',
      borderRadius: '5px !important',
    },
  },
  checked: {
    backgroundColor: '#fff !important',
    color:'#78AF36 !important',

  },
});

/**
 * ButtonGroup is an layer ontop of RadioGroup Component.
 * Simpler API to provide component rendered istead of default <Radio /> icon.
 *
 * @link https://github.com/subpublic/joinup/tree/development/client/components/radiogroup-control
 *
 * @example
 * <ButtonGroup
 *   defaultValue={alignment.horizontal}
 *   options={[
 *     {
 *       label: 'Left',
 *       value: ALIGNMENT_OPTIONS.start,
 *       component: <Icon>format_align_left</Icon>,
 *     },
 *     {
 *       label: 'Center',
 *       value: ALIGNMENT_OPTIONS.center,
 *       component: <Icon>format_align_justify</Icon>,
 *     },
 *     {
 *       label: 'Right',
 *       value: ALIGNMENT_OPTIONS.end,
 *       component: <Icon>format_align_right</Icon>,
 *     },
 *   ]}
 * />
 */
export const ButtonGroup: FC<Omit<IProps, 'name'>> = ({
  options,
  defaultValue,
  showOnlyIcon = false,
  ...props
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  const mergeOptions = (options: IOption[]) =>
    options.map(
      (option): IRadioGroupOption => ({ 
        label: showOnlyIcon ? '' : option.label,
        value: option.value,
        radioProps: {
          icon: option.component,
          checkedIcon: option.component,
          disableRipple: true,
          // classes: {
          //   root: classes.radio,
          //   checked: classes.checked,
          // },
          sx: {
            ...styles.radio,
            '&.Mui-checked': styles.checked
          }
        },
      })
    );

  return (
    <RadioGroup
      row
      withTooltip
      value={defaultValue}
      options={mergeOptions(options)}

      // classes={{
      //   formLabel: {
      //     root: classes.formlabelRoot,
      //   },
      //   radioGroup: {
      //     root: classes.formgroupRoot,
      //   },
      //   formControlLabel: {
      //     root: classes.formControlLabelRoot,
      //     label: classes.formControlLabel,
      //   },
      // }}
 
      {...props}
    />
  );
};
